"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentDocumentNoteToJSON = exports.AttachmentDocumentNoteFromJSONTyped = exports.AttachmentDocumentNoteFromJSON = void 0;
const runtime_1 = require("../runtime");
function AttachmentDocumentNoteFromJSON(json) {
    return AttachmentDocumentNoteFromJSONTyped(json, false);
}
exports.AttachmentDocumentNoteFromJSON = AttachmentDocumentNoteFromJSON;
function AttachmentDocumentNoteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'otherNote': !runtime_1.exists(json, 'otherNote') ? undefined : json['otherNote'],
    };
}
exports.AttachmentDocumentNoteFromJSONTyped = AttachmentDocumentNoteFromJSONTyped;
function AttachmentDocumentNoteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'otherNote': value.otherNote,
    };
}
exports.AttachmentDocumentNoteToJSON = AttachmentDocumentNoteToJSON;
//# sourceMappingURL=AttachmentDocumentNote.js.map